import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Formik, Field } from "formik";
import * as Yup from "yup";
import * as moment from "moment";
import Spinner from 'web/components/Spinner'
import AlertModal from 'web/components/AlertModal';
import YesNoModal from "web/components/YesNoModal";
import { Modal, ModalBody } from 'reactstrap';
import { CancelOrRescheduleModalWrapper, CancelOrRescheduleModalContentWrapper } from "./modalStyled";
import CloseIcon from "web/assets/images/CloseIcon.png";
import { RescheduleModalRadioConstants } from "./Constants";
import TextArea from 'web/components/form-elements/TextArea';
import DatePicker from "web/components/DatePicker";
import TimePickerInput from 'web/components/form-elements/TimePickerInput';
import RadioButton from 'web/components/form-elements/RadioButton';
import { cancelRescheduleOrderApi } from "redux/actions/myPickupOrders";

function CancelRescheduleModal(props) {
    const { modalData } = props
    const token = localStorage.getItem("token")
    const dispatch = useDispatch();
    let history = useHistory();
    const [loader, setLoader] = useState(false)
    const loaderVisible = useSelector(state => state.appReducer.loaderVisible)
    const [updatedDetailsStore, setUpdatedDetailsStore] = useState()
    const [alertModal, setAlertModal] = useState(false)
    const [alertModalContent, setAlertModalContent] = useState('')
    const [alertModalType, setAlertModalType] = useState()
    const [yesNoModalContent, setYesNoModalContent] = useState("");
    const [yesNomodal, setYesNoModal] = useState(false);

    const initialValues = () => {
        return (
            {
                cancelOrRescheduleRadio: 'cancel',
                rescheduleDate: moment().format('MM/DD/YYYY'),
                rescheduleFromTime: '08:00',
                rescheduleToTime: '17:00',
                comment: ''
            }
        )
    }

    const VALIDATION_SCHEMA = () => {
        return Yup.object().shape({
            rescheduleDate: Yup.mixed().when('cancelOrRescheduleRadio', {
                is: 'reschedule',
                then: Yup.date()
                    .typeError('Date must be a valid date')
                    .nullable()
                    .required('Date is required')
                    .min(moment().startOf('day'), 'Date cannot be in the past')
                    .max(moment().add(10, 'days').endOf('day'), 'Invalid Date'),
            }),
            rescheduleFromTime: Yup.string().when('cancelOrRescheduleRadio', {
                is: 'reschedule',
                then: Yup.string().required('Reschedule start time is required'),
            }),
            rescheduleToTime: Yup.string().when('cancelOrRescheduleRadio', {
                is: 'reschedule',
                then: Yup.string().required('Reschedule end time is required'),
            }),
            comment: Yup.string().max(200, 'Comment must be at most 200 characters')
        });
    };

    const submitForm = (values) => {
        setUpdatedDetailsStore(values)
        const fromTimeValue = parseInt(values?.rescheduleFromTime?.replace(":", ""));
        const toTimeValue = parseInt(values?.rescheduleToTime?.replace(":", ""));
        if (values?.cancelOrRescheduleRadio === 'reschedule' && toTimeValue <= fromTimeValue) {
            setAlertModalContent("Pickup window time is invalid.");
            setAlertModal(true);
            return
        } else {
            setYesNoModalContent(values?.cancelOrRescheduleRadio === 'reschedule' ? 'Are you sure you want to reschedule the order with the modified date?' : 'Are you sure you want to cancel the order?')
            setYesNoModal(true)
            setAlertModalType(values?.cancelOrRescheduleRadio === 'reschedule' ? 'reschedule' : 'cancel')
        }
    }

    const cancelRescheduleOrderFunction = async (values) => {
        let data = {
            orderId: modalData?.orderId,
            comment: values?.comment,
        }
        if (values?.cancelOrRescheduleRadio === 'reschedule') {
            data.rescheduleDate = moment(values?.rescheduleDate).format('MM/DD/YYYY')
            data.pickupAppointmentStartTime = values?.rescheduleFromTime
            data.pickupAppointmentEndTime = values?.rescheduleToTime
            data.rescheduledBy = modalData?.userType
        } else {
            data.cancelledBy = modalData?.userType
        }
        let url, response
        if (values?.cancelOrRescheduleRadio === 'cancel') url = '/order/pickup/order/cancel'
        else url = '/order/pickup/reschedule/request'
        response = await dispatch(cancelRescheduleOrderApi(url, data, token));
        if (response?.success) {
            setLoader(false)
            setAlertModalType(values?.cancelOrRescheduleRadio === 'cancel' ? 'cancelSuccess' : 'rescheduleSuccess')
            setAlertModalContent(response?.data?.msg);
            setAlertModal(!alertModal)
        } else {
            setLoader(false)
            if (response?.statusCode === 401) {
                history.push('./sign-in')
            } else {
                setAlertModalContent(response?.data?.error?.message || response?.data?.message || response?.message || 'Something went wrong, please try again in some time.');
                setAlertModal(!alertModal);
            }
        }
    }

    return (
        <CancelOrRescheduleModalWrapper>
            <Modal isOpen={true} centered={true} size={'lg'} className="cancel-reschedule-modal-style">
                <CancelOrRescheduleModalContentWrapper>
                    <ModalBody>
                        {(loaderVisible || loader) && <Spinner />}
                        <Formik
                            initialValues={initialValues()}
                            validationSchema={VALIDATION_SCHEMA()}
                        >
                            {(formikProps) => {
                                const { isValid, dirty, setFieldValue, values, errors, setFieldError } = formikProps;
                                return (
                                    <div className="outer-wrapper">
                                        <div className="main-header">
                                            <h4>Cancel or Reschedule Order</h4>
                                            <img src={CloseIcon} alt="close-icon" onClick={() => props.closeModal()} />
                                        </div>
                                        <div className="radio-selection-section">
                                            {RescheduleModalRadioConstants.map((value, index) => (
                                                <div className='col-6' key={index}>
                                                    <Field
                                                        component={RadioButton}
                                                        name='cancelOrRescheduleRadio'
                                                        id={value.value}
                                                        defaultValue={RescheduleModalRadioConstants[0].value}
                                                        onSelect={(e) => { }}
                                                        label={value.label}
                                                    />
                                                </div>
                                            ))}
                                        </div>
                                        {values?.cancelOrRescheduleRadio === 'reschedule' &&
                                            <>
                                                <div>
                                                    <p className="date-class">Requested Window : <span>{moment(modalData?.pickupDate).format('MM/DD/YYYY')} {modalData?.pickupAppointmentStartTime} - {modalData?.pickupAppointmentEndTime}</span></p>
                                                </div>
                                                <div className="reschedule-details-section">
                                                    <div>
                                                        <DatePicker
                                                            name='rescheduleDate'
                                                            minDOBirth={moment().format('MM/DD/YYYY')}
                                                            maxDOBirth={moment().add(10, 'days').endOf('day')}
                                                            value={values.rescheduleDate}
                                                            type="returnNormalDate"
                                                            callBackFun={(date, value) => {
                                                                setFieldValue('rescheduleDate', moment(date).format("MM/DD/YYYY"));
                                                            }}
                                                        />
                                                        {errors?.rescheduleDate && <span className="error-message">{errors?.rescheduleDate}</span>}
                                                    </div>
                                                    <div className="app-window-style">
                                                        <TimePickerInput
                                                            name='rescheduleFromTime'
                                                            type='time'
                                                            startTime={null}
                                                            showErrorMessages={true}
                                                            props={props}
                                                            selectedValue={values?.rescheduleFromTime}
                                                        />
                                                        <span className='toStyle'>To</span>
                                                        <TimePickerInput
                                                            name='rescheduleToTime'
                                                            type='time'
                                                            endTime={null}
                                                            showErrorMessages={true}
                                                            props={props}
                                                            selectedValue={values?.rescheduleToTime}
                                                        />
                                                    </div>
                                                </div>
                                            </>
                                        }
                                        <div className="comment-section-style">
                                            <p>Comment</p>
                                            <TextArea
                                                name="comment"
                                                maxLength="200"
                                            />
                                        </div>
                                        <div className="submit-button">
                                            <button
                                                disabled={!isValid}
                                                onClick={() => submitForm(values)}
                                            >Submit</button>
                                        </div>
                                    </div>
                                );
                            }}
                        </Formik>
                    </ModalBody>
                </CancelOrRescheduleModalContentWrapper>
            </Modal>

            <AlertModal
                isOpen={alertModal}
                toggle={() => setAlertModal(!alertModal)}
                content={alertModalContent}
                alertType='success'
                callBackAlert={() => {
                    if (alertModalType === 'cancelSuccess' || alertModalType === 'rescheduleSuccess') {
                        props.closeModal()
                        props.cancelRescheduleOrderSuccessCallback(alertModalType === 'cancelSuccess' ? 'cancel' : 'reschedule')
                    }
                }}
            />
            <YesNoModal
                isOpen={yesNomodal}
                toggle={() => setYesNoModal(!yesNomodal)}
                title=""
                content={yesNoModalContent}
                link={'/'}
                type={''}
                onClickHander={(val) => {
                    setYesNoModal(!yesNomodal)
                    if (val !== "no") cancelRescheduleOrderFunction(updatedDetailsStore)
                }}
            />
        </CancelOrRescheduleModalWrapper>
    );
}

export default CancelRescheduleModal;
